import { __decorate, __metadata } from "tslib";
// deep imports to fix circular deps in jest
import { AppRequestMethod } from '../request/request-method';
import { AppRequest } from '../app-request/app-request.decorator';
import { Model, Expose, ModelId } from '../model';
let GetI18nLanguageResponse = /*#__PURE__*/(() => {
  let GetI18nLanguageResponse = class GetI18nLanguageResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Object)], GetI18nLanguageResponse.prototype, "data", void 0);
  __decorate([Expose(), __metadata("design:type", String)], GetI18nLanguageResponse.prototype, "languageId", void 0);
  GetI18nLanguageResponse = __decorate([ModelId("GetI18nLanguageResponse") // auto-generated by generate-model-ids
  ], GetI18nLanguageResponse);
  return GetI18nLanguageResponse;
})();
export { GetI18nLanguageResponse };
// handler uses request headers to determine language.
// add a separate request if you require to get language data on server.
// warning: when changing path, it must be updated in libs\core\frontend-shared\src\lib\i18n\preloader.ts as well!
let GetI18nDataRequest = /*#__PURE__*/(() => {
  let GetI18nDataRequest = class GetI18nDataRequest extends Model {
    static {
      this.Response = GetI18nLanguageResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", String)], GetI18nDataRequest.prototype, "language", void 0);
  GetI18nDataRequest = __decorate([AppRequest('i18n', 'i18n-data', {
    httpMethod: AppRequestMethod.POST,
    disallowInternal: true,
    clientCache: {
      seconds: 15 * 60
    }
  }), ModelId("GetI18nDataRequest") // auto-generated by generate-model-ids
  ], GetI18nDataRequest);
  return GetI18nDataRequest;
})();
export { GetI18nDataRequest };
let GetI18nLanguagesResponse = /*#__PURE__*/(() => {
  let GetI18nLanguagesResponse = class GetI18nLanguagesResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Array)], GetI18nLanguagesResponse.prototype, "languageIds", void 0);
  GetI18nLanguagesResponse = __decorate([ModelId("GetI18nLanguagesResponse") // auto-generated by generate-model-ids
  ], GetI18nLanguagesResponse);
  return GetI18nLanguagesResponse;
})();
export { GetI18nLanguagesResponse };
let GetI18nLanguagesRequest = /*#__PURE__*/(() => {
  let GetI18nLanguagesRequest = class GetI18nLanguagesRequest extends Model {
    static {
      this.Response = GetI18nLanguagesResponse;
    }
  };
  GetI18nLanguagesRequest = __decorate([AppRequest('i18n', '', {
    httpMethod: AppRequestMethod.GET,
    clientCache: {
      seconds: 15 * 60
    }
  }), ModelId("GetI18nLanguagesRequest") // auto-generated by generate-model-ids
  ], GetI18nLanguagesRequest);
  return GetI18nLanguagesRequest;
})();
export { GetI18nLanguagesRequest };